import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import Clickable from 'components/Common/Clickable'
import { MediumButtonTypography } from 'LuxKit/Typography/ButtonTypography'
import { mediaQueryUp } from 'components/utils/breakpoint'
import focusStyle from 'styles/utils/focusStyle'
import ModalContext from 'contexts/ModalContext'
import { mediaHoverable } from 'lib/theme/mediaQueries'
import { rem } from 'polished'
import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const LoginButton = styled(Clickable)`
  ${MediumButtonTypography}
  font-family: ${props => props.theme.font.secondary.family};
  font-weight: ${props => props.theme.font.secondary.weight.regular};
  position: relative;
  white-space: nowrap;
  justify-content: center;
  text-decoration: none;
  flex-shrink: 0;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  background-image: none;
  display: inline-flex;
  align-items: center;
  text-align: center;
  transition: background-color 0.2s;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${props => props.theme.palette.brand.primary.normal};
  color: ${props => props.theme.palette.neutral.default.one};
  height: ${rem(32)};
  width: ${rem(64)};

  ${mediaQueryUp.tablet} {
    height: ${rem(40)};
    width: ${rem(72)};
  }

  &:not(:disabled) {
    ${mediaHoverable} {
      &:hover {
        color: ${props => props.theme.palette.neutral.default.eight};
        background-color: ${props => props.theme.palette.brand.primary.hover};
      }
    }

    &:focus-visible {
      ${focusStyle}
    }

    &:active {
      background-color: ${props => props.theme.palette.brand.primary.active};
      color: ${props => props.theme.palette.neutral.default.eight};
    }
  }
`

interface Props {
  className?: string
}

function NavBarLoginButton(props: Props) {
  const { className } = props

  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const onLoginClick = useCallback(() => showModal(<AccountAccessModal />), [showModal])

  const loginText = intl.formatMessage({
    id: 'PzcSUqTGzjiNHFXJC3x_',
    defaultMessage: 'Log in',
    description: 'Login button text in navigation bar on the login or signup page',
  })

  return <LoginButton onClick={onLoginClick} className={className}>
    {loginText}
  </LoginButton>
}

export default React.memo(NavBarLoginButton)
